<template>
    <v-form class="d-flex align-center" style="height: 95vh" v-model="valid">
        <v-container>
            <v-row>
                <v-col class="pr-7" cols="4">
                    <h1>{{ $t('resetYourPassword') }}</h1>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pr-7" cols="4">
                    <h3 class="mb-5">{{ $t('form.createNewPassword.header') }}</h3>
                    <v-text-field :rules="passwordRule" :label="$t('form.createNewPassword.label')" outlined type="password" v-model="password"/>
                </v-col>
                <v-col class="pr-7" cols="4">
                    <h3 class="mb-5">{{ $t('form.confirmNewPassword.header') }}</h3>
                    <v-text-field :rules="confirmPasswordRule" :label="$t('form.confirmNewPassword.label')" outlined type="password" v-model="confirmPassword"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="5">
                    <v-btn @click="resetPassword" class="text-center" v-on:keyup.enter="resetPassword">{{ $t('setNewPassword') }}</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import Repository from '../../../repositories/auth';
    export default {
        name: "FinishResetPassword",
        data() {
            return {
                valid: false,
                key: '',
                password: '',
                confirmPassword: '',
                passwordRule: [
                    p => !!p || this.$t('form.createNewPassword.rule1'),
                    p => (p || '' ).length < 60 || this.$t('form.createNewPassword.rule2'),
                    p => (p || '' ).length > 7 || this.$t('form.createNewPassword.rule3'),
                ],
                confirmPasswordRule: [
                    p => !!p || this.$t('form.confirmNewPassword.rule1'),
                    p => p === this.password || this.$t('form.confirmNewPassword.rule2'),
                ],
            };
        },
        created() {
            this.key = this.$route.query.key;
        },
        methods: {
            resetPassword() {
                if(this.valid) {
                    Repository.finishResetPassword(this.password, this.key).then((response) => {
                        if(response.status < 400) {
                            alert(this.$t('yourPasswordHasBeenReset'));
                            this.$router.push('/');
                        }
                    });
                }
            },
        },
    }
</script>

<style scoped>

</style>

<i18n>
{
    "en":{
        "resetYourPassword": "Reset your password",
        "setNewPassword": "Set New Password",
        "yourPasswordHasBeenReset": "Your password has been reset",


        "form":{
            "createNewPassword":{
                "header": "Create a new password.",
                "label": "Password",
                "rule1": "Password is required",
                "rule2": "Password should have less than 60 characters.",
                "rule3": "Password should have at least 7 characters."
            },
            "confirmNewPassword":{
                "header": "Confirm new password.",
                "label": "Confirm Password",
                "rule1": "Password is required",
                "rule2": "Passwords don´t match"
            }
        }
    },
    "es":{
        "resetYourPassword": "Recupera tu contraseña",
        "setNewPassword": "Establecer nueva contraseña",
        "yourPasswordHasBeenReset": "Tu contraseña ha sido recuperada",

        "form":{
            "createNewPassword":{
                "header": "Crear nueva contraseña.",
                "label": "Contraseña",
                "rule1": "La contraseña es obligatoria",
                "rule2": "La contraseña debe de tener menos de 60 caracteres.",
                "rule3": "La contraseña debe de tener al menos 7 caracteres."
            },
            "confirmNewPassword":{
                "header": "Confirmar nueva contraseña",
                "label": "Confirmar contraseña",
                "rule1": "La contraseña es obligatoria",
                "rule2": "Las contraseñas no son iguales"
            }
        }
    }
}
</i18n>
